export const NAT_TYPES = {
  internalNatToIp: 'INTERNAL_IP',
  internalNatToVm: 'INTERNAL_VM_NIC',
  publicNatToIp: 'PUBLIC_IP',
  publicNatToVm: 'PUBLIC_VM_NIC',
};
